<script setup lang="ts"></script>
<template>
  <div id="tcf-message">
    <span>No File Selected</span>
    <div class="info-message">
      <i class="fas fa-info-circle"></i>
      <span>Please ensure the file you upload is under 20MB in size</span>
    </div>
  </div>
</template>
<style scoped lang="scss">
#tcf-message {
  margin-top: 10px;
  display: inline-block;
}

.info-message {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  border: 1px solid #51a0ba;
  border-radius: 5px;
  padding: 7px 10px;
  background-color: lightblue;
  margin-top: 10px;

  i {
    color: #086280;
    font-size: 16px;
  }
}
</style>
